<template>
	<div class = "goods-group-div">
		<van-sidebar v-model="groupIndex">
		  <van-sidebar-item v-for="(item,index) in groupList" :key="index">
			  <template #title>
				  <div class = "group-div" @click="clickGroup(index)">
					  <img :src="item.thumb">
					  <div class = "group-name">{{item.name}}</div>
				  </div>
			  </template>
		  </van-sidebar-item>
		</van-sidebar>
	</div>
</template>

<script>
	import { goodsListSelect } from '@/request/api';
	import { Sidebar, SidebarItem} from 'vant';
import { mapGetters } from 'vuex';
	export default {
		name: 'ComGroup',
		computed: mapGetters(["sShop"]),
		components: {
		      [SidebarItem.name]: SidebarItem,
		      [Sidebar.name]: Sidebar
		      
		 },
		 created: function() {
		      this.selectGroupList();
		 },
		 watch:{
			 groupId(val){
				 this.groupIndex = val
			 }
		 },
		 props:['groupId'],
		data(){
			return {
				groupIndex:0,
				groupList:[]
			}
		},
		methods:{
			selectGroupList(){
				goodsListSelect({
					storeId:this.sShop.storeId
				}).then(res => {
					this.groupList = res;							  
				})  
			},
			clickGroup(jumpIndex){
				this.$emit('clickGroup',jumpIndex)
			}
		}
	}
</script>

<style scoped>
	
	.group-div>img{
		display: block;
		margin: 3px auto;
		width: 35px;
		height: 35px;
	}
	
	.group-div>div{
		font-size: 12px;
		width: 100%;
		margin: 3px auto;
		text-align: center;
	}
	.group-name {
		padding: 0 10px;
	}
	.goods-group-div{
		text-align: center;
		width: 100%;
	}
	
	.goods-group-div .van-sidebar-item--select::before {
		background-color: #ffffff;
	}
	
	.goods-group-div .van-sidebar {
		height: 100%;
		width: 100%;
		
	}
	
	.goods-group-div .van-sidebar-item {
		padding: 5px 0;
	}
	.goods-group-div .van-sidebar-item__text {
		width: 100%;
	}
	
	
</style>
